export enum LocaleEnum {
  EU = 'eu',
  US = 'us'
}